import { render } from "./PositionRoleManagement.vue?vue&type=template&id=058b0c2c&scoped=true"
import script from "./PositionRoleManagement.vue?vue&type=script&lang=js"
export * from "./PositionRoleManagement.vue?vue&type=script&lang=js"

import "./PositionRoleManagement.vue?vue&type=style&index=0&id=058b0c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b0c2c"]])

export default __exports__